const $ = jQuery.noConflict();

// Estado global dinámico
let available_variations = [];
let isProgrammaticChange = false;
let sync_selects = true;
let sync_radio_buttons = true;

/**
 * Función de inicialización del configurador (ejecutar en carga inicial y tras AJAX)
 */
function init_product_builder(context = document) {
    const $context = $(context);
    const $form = $context.find('form.variations_form');

    if (!$form.length) return;

    // 1. OBTENER LAS NUEVAS VARIACIONES DEL FORMULARIO ACTUAL
    available_variations = $form.data('product_variations') || window.variaciones || [];

    if (!available_variations || !available_variations.length) return;

    // Prevenir el evento wc-variation-form estándar si usas el tuyo propio
    $form.off('change.wc-variation-form');

    /* WooCommerce poda las opciones de cada select segun lo elegido en los demas, en todas
       direcciones. Si se le deja, el select de abajo pierde opciones que el configurador si
       ofrece y el valor elegido no llega al formulario. La disponibilidad la decide aqui
       update_options_availability, de arriba abajo, sobre los radios. */
    $form.off('update_variation_values.wc-variation-form');
    restoreSelectOptions($form);

    // 2. Partir de los atributos por defecto (o de la URL) y completarlos de arriba abajo
    const orderedKeys = getOrderedKeys($form);
    const resolved = resolveTopDown(getCurrentAttributes($form), orderedKeys);

    setVariationAttributes(resolved, $form);
    Object.entries(resolved).forEach(([name, val]) => setRadioCheckedUI(name, val));
    update_options_availability(resolved, orderedKeys);

    const variation = findMatchingVariation(resolved);
    if (variation) {
        displayVariation(variation, $form);
    }

    // Guardar copia del botón de añadir al carrito
    let $originalButton = $form.find('.single_add_to_cart_button');
    if ($originalButton.length) {
        $form.data('cloned_button', $originalButton.clone(true));
    }
}

// Exponer la función globalmente para poder llamarla desde tu script AJAX
window.init_product_builder = init_product_builder;

/* ================= LISTENERS CON DELEGACIÓN EN DOCUMENT ================= */
/* Con $(document).on() NO hace falta volver a vincular los eventos tras un AJAX */

jQuery(document).ready(function ($) {

    // Inicialización al cargar la web por primera vez
    init_product_builder();

    // Evento WooCommerce prevent default
    $(document).on('check_variations', 'form.variations_form', function(evt) {
        evt.stopImmediatePropagation();
        evt.preventDefault();
        return false;
    });

    // Evento Click en Radios / Pills
    $(document).on('click', 'form.variations_form .sc-radio-pill', function (e) {
        const $radio = $(this).find('input[type=radio]');
        if (!$radio.length || $radio.prop('disabled')) return;
        setRadioCheckedUI($radio.attr('name'), $radio.val());
        $radio.trigger('change');
    });

    // Evento Change en SELECTS
    $(document).on('change', 'form.variations_form .variations select', function () {
        const $form = $(this).closest('form.variations_form');
        sync_radio_buttons_attrs(this);

        if (isProgrammaticChange) return;

        const orderedKeys = getOrderedKeys($form);
        const resolved = resolveTopDown(getCurrentAttributes($form), orderedKeys);

        setVariationAttributes(resolved, $form);
        update_options_availability(resolved, orderedKeys);

        const variation = findMatchingVariation(resolved);
        if (variation) {
            displayVariation(variation, $form);
        } else {
            showNotAvailableMessage($form);
        }
    });

    // Evento Change en Radios de variaciones
    $(document).on('change', 'form.variations_form .sc-variation-radios input', function () {
        setRadioCheckedUI($(this).attr('name'), $(this).val());
        sync_selects_attrs(this);
    });

    // Evento Click en Etiquetas de Imagen
    $(document).on('click', 'form.variations_form .sc-row-images label[for]', function(e) {
        const forId = $(this).attr("for");
        const $radio = $(`#${CSS.escape(forId)}`);
        if (!$radio.length || $radio.prop("disabled")) return;
        setRadioCheckedUI($radio.attr("name"), $radio.val());
        $radio.trigger("change");
    });

    // Evento show_variation (Botón Where To Buy vs Añadir al Carrito)
    $(document).on('show_variation', 'form.variations_form', function(event, variation) {
        
        const $form = $(this);
        let venta_web = variation.venta_web == 1 || variation.venta_web === true;
        let $currentButton = $form.find('.single_add_to_cart_button, .where-to-buy-active');
        let $clonedButton = $form.data('cloned_button');
        const showWhereToBuy = !venta_web && !!variation.wtb_btn_html;

        if (showWhereToBuy) {
            let $newButton = $(variation.wtb_btn_html);
            $currentButton.replaceWith($newButton);
        } else if ($clonedButton && $currentButton.hasClass('where-to-buy-active')) {
            let $restoredButton = $clonedButton.clone(true);
            $currentButton.replaceWith($restoredButton);
        }

        /* Con el primario en "Where to Buy", "Find in store" llevaba al mismo sitio y quedaban
           dos botones para lo mismo: se esconde mientras dure esa variacion y vuelve en cuanto
           se elige una que si se vende. Se oculta con jQuery y no con la clase hidden porque el
           boton lleva lg:flex, que la ganaria a partir del breakpoint grande. */
        $form.find('.sc-find-in-store').toggle(!showWhereToBuy);

        update_url_with_attrs($form);
    });
});

/* ================= HELPERS ACTUALIZADOS ================= */

function setRadioCheckedUI(name, value) {
    const $all = jQuery(`.sc-variation-radios input[name="${name}"]`);
    $all.prop('checked', false).attr('aria-checked', 'false')
        .closest('.button-group, .sc-radio-pill').removeClass('is-checked selected active');

    jQuery(`.sc-variation-images label[for^="${name}-"]`).removeClass("is-checked selected active");

    const id = `${name}-${value}`;
    const $target = jQuery(`.sc-variation-radios #${CSS.escape(id)}`);
    if ($target.length) {
        $target.prop('checked', true).attr('aria-checked', 'true');
        $target.closest('.button-group, .sc-radio-pill').addClass('is-checked selected active');
        const $outer = $target.siblings('.outer-circle');
        $outer.toggleClass('checked', true);
    }

    jQuery(`.sc-variation-images label[for="${id}"]`).addClass("is-checked selected active");

    $all.each(function(){
        if (this !== $target.get(0)) {
            jQuery(this).siblings('.outer-circle').removeClass('checked');
        }
    });
}

/* La compatibilidad se evalua de arriba abajo: una opcion solo depende de lo elegido en los
   atributos que tiene por encima. El primero nunca se bloquea; si al cambiar uno de arriba la
   seleccion de uno de abajo deja de existir, se sustituye por la primera opcion valida. */
function update_options_availability(attrs, orderedKeys) {
    orderedKeys.forEach((key, i) => {
        const candidates = variationsMatchingPrefix(attrs, orderedKeys.slice(0, i));
        jQuery(`.sc-variation-radios input[name="${key}"]`).each(function () {
            const isValid = candidates.some(v => attributeMatches(v, key, this.value));
            set_radio_availability(jQuery(this), isValid);
        });
    });
}

function set_radio_availability($radio, isValid) {
    const $wrap = $radio.closest('.button-group, .sc-radio-pill');
    $radio.prop('disabled', !isValid);

    if (!isValid) {
        $wrap.addClass('disabled').removeClass('is-checked selected active');
        $radio.attr('aria-disabled', 'true');
    } else {
        $wrap.removeClass('disabled');
        $radio.removeAttr('aria-disabled');
    }
}

function sync_selects_attrs(radio_btn) {
    const name  = jQuery(radio_btn).attr('name');
    const value = jQuery(radio_btn).val();

    if (!sync_selects) return;

    sync_radio_buttons = false;
    jQuery(`select[name="${name}"]`).val(value).trigger('change');
    sync_radio_buttons = true;
}

function sync_radio_buttons_attrs(select) {
    const name  = jQuery(select).attr('name');
    const value = jQuery(select).val();

    if (!sync_radio_buttons) return;
    if (!value) return;

    sync_selects = false;
    setRadioCheckedUI(name, value);
    sync_selects = true;
}

function getCurrentAttributes($form) {
    const attrs = {};
    $form.find('.variations select').each(function() {
        const name = jQuery(this).attr('name');
        const val  = jQuery(this).val();
        if (val) attrs[name] = val;
    });
    return attrs;
}

function restoreSelectOptions($form) {
    $form.find('.variations select').each(function () {
        const originalHtml = jQuery(this).data('attribute_html');
        if (!originalHtml) return;
        const value = jQuery(this).val();
        jQuery(this).html(originalHtml).val(value);
    });
}

/* Arte pinta el mismo atributo en dos select, asi que los nombres se deduplican. */
function getOrderedKeys($form) {
    const keys = $form.find('.variations select').map(function () {
        return jQuery(this).attr('name');
    }).get();
    return [...new Set(keys)];
}

/* En WooCommerce una variacion con el atributo vacio vale para cualquier opcion. */
function attributeMatches(variation, key, value) {
    const own = variation.attributes[key];
    return own === '' || own === undefined || own === value;
}

function variationsMatchingPrefix(attrs, keys) {
    return (available_variations || []).filter(variation =>
        keys.every(key => !attrs[key] || attributeMatches(variation, key, attrs[key]))
    );
}

/* Las opciones de un atributo en el orden en que se ven en pantalla. */
function attributeValuesInOrder(key) {
    let values = jQuery(`.sc-variation-radios input[name="${key}"]`).map(function () {
        return this.value;
    }).get();

    if (!values.length) {
        values = jQuery(`.variations select[name="${key}"] option`).map(function () {
            return this.value;
        }).get();
    }

    return [...new Set(values.filter(Boolean))];
}

/* Recorre los atributos de arriba abajo: cada uno conserva su valor si es compatible con lo
   elegido por encima y, si no, toma la primera opcion compatible. */
function resolveTopDown(attrs, orderedKeys) {
    const resolved = {};

    orderedKeys.forEach((key, i) => {
        const candidates = variationsMatchingPrefix(resolved, orderedKeys.slice(0, i));
        const isValid = value => candidates.some(v => attributeMatches(v, key, value));

        const value = attrs[key] && isValid(attrs[key])
            ? attrs[key]
            : attributeValuesInOrder(key).find(isValid);

        if (value) resolved[key] = value;
    });

    return resolved;
}

function findMatchingVariation(attrs) {
    if (!available_variations) return null;
    return available_variations.find(variation =>
        Object.entries(attrs).every(([key, val]) => attributeMatches(variation, key, val))
    );
}

function setVariationAttributes(attrs, $form) {
    isProgrammaticChange = true;
    sync_radio_buttons = true;
    $form.find('.variations select').each(function() {
        const name = jQuery(this).attr('name');
        const val  = attrs[name];
        const hasOption = jQuery(this).find('option').filter(function () { return this.value === val; }).length;
        if (val && hasOption && jQuery(this).val() !== val) {
            jQuery(this).val(val).trigger('change');
        }
    });
    sync_radio_buttons = false;
    isProgrammaticChange = false;
}

function displayVariation(variation, $form) {
    const $summary = jQuery('.summary');
    const $id = $summary.find('input[name=variation_id]');

    /* El codigo va antes de la guarda: WooCommerce resuelve la variacion por su cuenta al
       cargar y deja puesto variation_id sin escribir este codigo, asi que si llega antes que
       el configurador la guarda saldria con el del producto padre todavia en pantalla.
       Escribir el mismo texto otra vez no cuesta nada. */
    $(".sku_wrapper .sku").text(variation.sku);

    /* El mismo cambio llega varias veces seguidas. Sincronizar radios y selects dispara el
       change de cada select del atributo, y en arte ese atributo se pinta en dos --el grupo
       sin marco y el de acabados--, asi que un solo clic reentraba aqui una y otra vez. Cada
       found_variation hace que WooCommerce tire la galeria entera y la vuelva a montar: se
       reconstruia ocho veces por clic, medio segundo de bloqueo con el cursor parpadeando y
       la foto tardando en aparecer. Si la variacion ya es la que se esta enseñando no hay
       nada que rehacer. */
    if (parseInt($id.val() || '0', 10) === parseInt(variation.variation_id, 10)) {
        return;
    }

    $form.trigger('found_variation', [variation]);
    $form.trigger('show_variation', [variation]);

    let price = variation.price_html || variation.display_regular_price;
    price = price != null ? price.toString() : '';
    $summary.find('.woocommerce-variation-price').html(price);

    $summary.find(`.wcpbc-price-${variation.variation_id}`).removeClass('loading');
    $id.val(variation.variation_id);
}

function showNotAvailableMessage($form) {
    $form.trigger('reset_data');
    $form.trigger('hide_variation');
}

function update_url_with_attrs($form) {
    
    let url = new URL(window.location.href);

    // Recorrer los atributos seleccionados en el formulario
    $form.find('select[name^="attribute_"]').each(function() {
        let name = $(this).attr('name');
        let val = $(this).val();

        if (val) {
            url.searchParams.set(name, val);
        } else {
            url.searchParams.delete(name);
        }
    });

    // Actualizar la URL dinámicamente sin recargar la página
    window.history.replaceState({}, '', url.toString());
}